import React, { useMemo } from "react";
import { Card, QueryResult, hasActiveFilters } from "@sscs/ui";
import { getPageItems, getQueryStatus, sortItems } from "@sscs/utils";
import { useReportDispatch, useReportSelector } from "../../hooks";
import { useGetComponentSecretsQuery } from "../../services/fileBrowser.api";
import { filterUpdated, paginationUpdated, selectFilter, selectPagination, selectSort, sortUpdated, } from "../store/secretsSlice";
import { useGetFileAndReportId } from "../useGetFileAndReportId";
import Filter from "./filter/Filter";
import SecretsTable from "./secretsTable/SecretsTable";
import { filterSecret, initFilter, specialCasesForSorting, } from "./utils";
const Secrets = () => {
    const dispatch = useReportDispatch();
    const { fileId, reportId } = useGetFileAndReportId();
    const { data = { secrets: [] }, isLoading, isFetching, isError, error, } = useGetComponentSecretsQuery({
        reportId: reportId,
        fileId: fileId !== null && fileId !== void 0 ? fileId : "",
    });
    const { services, endpoints } = useMemo(() => {
        const services = [];
        const endpoints = [];
        for (const secret of data.secrets) {
            const existingService = services.find((service) => service.name === secret.service);
            if (existingService) {
                if (secret.exposed) {
                    existingService.exposed = true;
                }
            }
            else {
                services.push({
                    name: secret.service,
                    exposed: secret.exposed,
                });
            }
            for (const endpoint of secret.endpoints) {
                const endpointItem = {
                    label: endpoint.label,
                    location: endpoint.location,
                    exposed: secret.exposed,
                };
                const existingEndpoint = endpoints.find((endpoint) => endpoint.label === endpointItem.label &&
                    endpoint.location === endpointItem.location);
                if (existingEndpoint) {
                    if (secret.exposed) {
                        existingEndpoint.exposed = true;
                    }
                }
                else {
                    endpoints.push(endpointItem);
                }
            }
        }
        return { services, endpoints };
    }, [data.secrets]);
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const pagination = useReportSelector(selectPagination);
    const filteredSecrets = useMemo(() => data.secrets.filter((secret) => filterSecret(secret, filter)), [data.secrets, filter]);
    const sortedSecrets = sortItems(filteredSecrets, {
        property: sort.property,
        reverse: sort.reverse,
    }, specialCasesForSorting);
    const activeItems = getPageItems(sortedSecrets, pagination.currentPage, pagination.itemsPerPage);
    return (React.createElement(React.Fragment, null,
        React.createElement(Card.Filters, { found: {
                id: "secrets-clear-all-filters",
                count: sortedSecrets.length,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => dispatch(filterUpdated(initFilter)),
            } },
            React.createElement(Filter, { filter: filter, services: services, endpoints: endpoints, onFilterChange: (newFilter) => dispatch(filterUpdated(newFilter)) })),
        React.createElement(QueryResult, { status: getQueryStatus({
                data,
                isLoading,
                isFetching,
                isError,
                error,
            }) },
            React.createElement(SecretsTable, { secrets: activeItems, matchCount: sortedSecrets.length, endpointFilter: filter.endpoint, filters: {
                    active: hasActiveFilters(initFilter, filter),
                    onReset: () => dispatch(filterUpdated(initFilter)),
                }, pagination: pagination, handlePaginationChange: (newPagination) => dispatch(paginationUpdated(newPagination)), sort: sort, handleSortChange: (newSort) => dispatch(sortUpdated(newSort)) }))));
};
export default Secrets;
//# sourceMappingURL=Secrets.js.map